import { render, staticRenderFns } from "./RadioValues.vue?vue&type=template&id=2d9c6e47&"
import script from "./RadioValues.vue?vue&type=script&lang=js&"
export * from "./RadioValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports